import { Component, OnInit, inject } from '@angular/core';

import { Answer, SendTypes } from 'src/app/core/api/models';
import { CompetitionParserService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';
import { CreatePollParserCommand } from '../../../../../core/api/models/create-poll-parser-command';
import { PollParserType } from '../../../../../core/api/models/poll-parser-type';
import { SmsBodyModule } from '../../../../../shared/components/sms-body/sms-body.module';
import { BaseParserDiagramComponent } from '../../base-parser/base-parser-diagram.component';
import { BaseParserFormComponent } from '../../base-parser/base-parser-form.component';
import { UpdatePollParserCommand } from './../../../../../core/api/models/update-poll-parser-command';

@Component({
  selector: 'app-competition-parser-form-page',
  templateUrl: './competition-parser-form-page.component.html',
  styleUrls: ['./competition-parser-form-page.component.scss'],
  imports: [BaseFormModule, SmsBodyModule, BaseParserDiagramComponent],
})
export class CompetitionParserFormPageComponent
  extends BaseParserFormComponent
  implements OnInit
{
  protected currentService = inject(CompetitionParserService);
  responses?: Array<Answer>;
  get SendTypes() {
    return SendTypes;
  }
  constructor() {
    super();
  }

  //#region init
  ngOnInit() {
    try {
      this.model.type = PollParserType.Competition;
      super.ngOnInit();
      this.responses = JSON.parse(JSON.stringify(this.model.answers));
      ConsoleService.info('res', this.responses);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  setPageTitle() {
    try {
      if (this.formPageConfig.isEditMode)
        this.title = this.pageVocabs + 'competitionEditTitle';
      else this.title = this.pageVocabs + 'competitionAddTitle';
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.services);
    }
  }

  //#endregion

  //#region api

  baseCreateApi(model: CreatePollParserCommand) {
    this.unSubs();
    this.loading = true;
    model.type = PollParserType.Competition;
    this.currentService
      .competitionParserCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  baseUpdateApi(model: UpdatePollParserCommand) {
    this.unSubs();
    this.loading = true;

    this.currentService
      .competitionParserUpdatePut({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }
  //#endregion
}
